var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoHollow = function SvgInfoHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    style: {
      color: "#3b7cc9"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 31.667c-6.443 0-11.667-5.224-11.667-11.667S13.557 8.333 20 8.333 31.667 13.557 31.667 20 26.443 31.667 20 31.667ZM5 20c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15Zm16.667-6.667a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0Zm-1.665 15h1.665a1.667 1.667 0 0 0 0-3.333v-6.667c0-.92-.747-1.666-1.667-1.666h-1.667a1.667 1.667 0 0 0 0 3.333v5a1.667 1.667 0 0 0 0 3.333h1.67Z",
    clipRule: "evenodd"
  })));
};
export default SvgInfoHollow;